export const ADMIN_ROLE = 'admin';
export const MANAGER_ROLE = 'manager';
export const TEAM_MEMBER_ROLE = 'team_member';

export type RoleType = keyof typeof ROLES;

export const ROLES = {
    admin: {
        value: ADMIN_ROLE,
        label: 'commons:roles.admin'
    },
    manager: {
        value: MANAGER_ROLE,
        label: 'commons:roles.manager'
    },
    team_member: {
        value: TEAM_MEMBER_ROLE,
        label: 'commons:roles.team_member'
    }
} as const;

export const ASSIGNABLE_ROLES = [ROLES.team_member, ROLES.manager];
